module.exports = __webpack_public_path__ + "static/media/iacsd-logo.2f043029.png";